import { format } from 'date-fns';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, inject, Modal, ModalHandle } from 'Mri.Web.Common';
import * as React from 'react';
import { BsPlusSquare } from '@react-icons/all-files/bs/BsPlusSquare';
import { AppStore } from '../Core/AppStore';
import { FavoriteButton } from '../Core/FavoriteButton';
import { ZendeskLink } from '../Core/ZendeskLink';
import { ActiveDisplay } from './ActiveDisplay';
import { DisplaysStore } from './DisplaysStore';

export interface ITicketsModalProps {
    readonly display: ActiveDisplay;
    readonly modalHandle: ModalHandle;
    readonly history: any;
}

@autoinject
@observer
export class TicketsModal extends React.Component<ITicketsModalProps> {
    public render() {
        return (
            <Modal
                title={this.title}
                modalHandle={this.props.modalHandle}
                footerClass="d-none"
                size="lg"
                className="my-2"
                onOpened={this.loadAsync}
            >
                <div className="container-fluid">
                    <div className="row">
                        {!!this.tickets?.length &&
                            this.tickets.map(t => (
                                <div key={t.ticketId} className="col-md-6">
                                    <ul className="list-group h-100">
                                        <div className="list-group-item d-block my-2 h-100">
                                            <div className="badge bg-info float-end">{t.status}</div>

                                            <div className="align-items-start">
                                                <ZendeskLink id={t.ticketId} className="btn-link">
                                                    <b>
                                                        #{t.ticketId} {t.subject}
                                                    </b>
                                                </ZendeskLink>

                                                <p className="list-group-item-text mb-0">
                                                    <b>Created: </b>
                                                    {format(t.dateCreated, 'EEEE, MMMM do yyyy, h:mm:ss a')}
                                                </p>
                                            </div>
                                        </div>
                                    </ul>
                                </div>
                            ))}
                        {!this.tickets?.length && <p>No Open Tickets</p>}
                    </div>
                </div>
            </Modal>
        );
    }

    @bind
    private async loadAsync() {
        try {
            await this.displaysStore.loadOpenTicketsAsync(this.props.display.serialNumber);
        } catch (e: any) {
            this.appStore.setError(e);
        }
    }

    @computed
    private get tickets() {
        return this.displaysStore.openTickets.get(this.props.display.serialNumber);
    }

    @computed
    private get title() {
        return (
            <div className="w-100 text-center">
                <a className="align-self-center float-start ms-3">
                    <FavoriteButton display={this.props.display} className="f-24" />
                </a>

                <span className="fw-bold">
                    <BsPlusSquare /> Tickets: {this.props.display.serialNumber}
                </span>
            </div>
        );
    }

    @inject
    private appStore!: AppStore;
    @inject
    private displaysStore!: DisplaysStore;
}
